export const ColorPalette = {
  Transparent: 'transparent',
  HEX: {
    White: '#FFFFFF',
    WhiteCoffee: '#E4DDDB',
    GhostWhite: '#F9F9F9',
    Black: '#000000',
    ChineseBlack: '#111111',
    ChineseBlack2: '#151312',
    RaisinBlack: '#22201F',
    BlackOlive: '#423B39',
    BlackOlive2: '#403735',
    Seashell: '#FFF2F1',
    Linen: '#FFEEEB',
    OriolesOrange: '#FF441F',
    OriolesOrange2: '#FF4420',
    OriolesOrange3: '#FF431F',
    OriolesOrange4: '#F94C13',
    OriolesOrange5: '#F6500F',
    BrightOrange: '#F4BF31',
    TartOrange: '#FF4949',
    SafetyOrange: '#FF7701',
    VeryPaleOrange: '#FFE5BD',
    PhilippineOrange: '#FF7500',
    OrangeSoda: '#FF593F',
    OutrageousOrange: '#FF6D48',
    OrangeWeb: '#FFA500',
    Red: '#FF0000',
    RedRYB: '#FF2725',
    RedRYB2: '#F53020',
    RedRYB3: '#FE2826',
    RedPigment: '#FA2626',
    RedPigment2: '#FF2426',
    PortlandOrange: '#FA5236',
    PortlandOrange2: '#FF4D2A',
    PastelRed: '#F75D63',
    CoralRed: '#FA4536',
    CoralRed2: '#FF4032',
    DeepCarminePink: '#FA2D29',
    Yellow: '#FFFF00',
    SizzlingSunrise: '#FCDB00',
    AmberSAEECE: '#FF7D00',
    GargoyleGas: '#FFD145',
    AtomicTangerine: '#FF9259',
    VerySoftYellow: '#F3F9A7',
    VividGamboge: '#FF9700',
    OuterSpace: '#484D51',
    OuterSpace2: '#43484D',
    OuterSpace3: '#484D52',
    OuterSpace4: '#474D51',
    OuterSpace5: '#464B4F',
    PhilippineGray: '#8C8B8B',
    DimGray: '#626E75',
    DimGray2: '#706967',
    Gainsboro: '#DDDDDD',
    Manatee: '#939DA3',
    Manatee2: '#929DA4',
    LightSilver: '#D8D8D8',
    LightSilver2: '#DBD9D9',
    LightGray: '#D4D4D4',
    LightGray2: '#D3D3D3',
    BrightGray: '#ECECEC',
    BrightGray2: '#EBF0F1',
    BrightGray3: '#EDECEC',
    BrightGray4: '#EBEBEB',
    BrightGray5: '#E5EDEF',
    BrightGray6: '#EEEDED',
    BrightGray7: '#E4E9EE',
    BrightGray8: '#EEEEEE',
    BrightGray9: '#EFEFEF',
    LavenderGray: '#C3CACF',
    Alabaster: '#ECE9E7',
    AntiFlashWhite: '#F0F2F4',
    AntiFlashWhite2: '#F1F1F1',
    AntiFlashWhite3: '#EFF1F3',
    AntiFlashWhite4: '#F2F2F2',
    AntiFlashWhite5: '#EFF2F4',
    FloralWhite: '#FEF6F4',
    FloralYellow: '#FAF5E1',
    Cultured: '#F9F9F8',
    Cultured2: '#F4F4F4',
    Cultured3: '#F5F5F5',
    Cultured4: '#F3F5F7',
    Cultured5: '#F7F8F9',
    Cultured6: '#F7F7F7',
    Lotion: '#FAFAFA',
    Lotion2: '#FBFBFB',
    GraniteGray: '#656565',
    GraniteGray2: '#666666',
    MetallicSilver: '#9FAAB7',
    QuickSilver: '#A3A3A3',
    AmericanSilver: '#D0D0D0',
    Platinum: '#E2E2E2',
    Platinum2: '#E5E5E4',
    ChineseSilver: '#CCCCCC',
    ChineseSilver2: '#C8CED1',
    PhilippineSilver: '#B8B4B4',
    PhilippineSilver2: '#B8B8B8',
    DavysGrey: '#555A60',
    DavysGrey2: '#555555',
    DavysGrey3: '#575463',
    SonicSilver: '#70777B',
    SonicSilver2: '#757575',
    DarkCharcoal: '#333333',
    PineTree: '#332927',
    PineTree2: '#332A27',
    PineTree3: '#332928',
    Gunmetal: '#2A3338',
    Apple: '#5ECF42',
    Mantis: '#76D661',
    UFOGreen: '#2EC565',
    UFOGreen2: '#3BCC67',
    PastelGreen: '#6CE36F',
    PastelGreen2: '#6BCF76',
    Emerald: '#53C76A',
    GreenPigment: '#1BBA54',
    GreenPantone: '#13B84E',
    GreenPantone2: '#15B84E',
    MagicMint: '#C0EDD0',
    CharlestonGreen: '#252D31',
    CambridgeBlue: '#A5C6A4',
    RussianGreen: '#678F66',
    BlueVioletCrayola: '#7959C1',
    BlueViolet: '#7726FD',
    BlueViolet2: '#8F3AFC',
    BlueViolet3: '#9428DC',
    VioletRYB: '#5E00BE',
    Ceil: '#9494C2',
    DarkBlueGray: '#66668F',
    CongoPink: '#FF7F7F',
    SilverPink: '#CAB4B4',
    DeepTaupe: '#756262',
    DeepTaupe2: '#806260',
    Verdigris: '#449AAA',
    PastelBlue: '#B2C3CD',
    ColumbiaBlue: '#CFD7E1',
  },
  RGB: {
    White: '255, 255, 255',
    WhiteCoffee: '228, 221, 219',
    GhostWhite: '249, 249, 249',
    Black: '0, 0, 0',
    ChineseBlack: '17, 17, 17',
    ChineseBlack2: '21, 19, 18',
    RaisinBlack: '34, 32, 31',
    BlackOlive: '66, 59, 57',
    BlackOlive2: '64, 55, 53',
    Seashell: '255, 242, 241',
    Linen: '255, 238, 235',
    OriolesOrange: '255, 68, 31',
    OriolesOrange2: '255, 68, 32',
    OriolesOrange3: '255, 67, 31',
    OriolesOrange4: '249, 76, 19',
    OriolesOrange5: '246, 80, 15',
    TartOrange: '255, 73, 73',
    SafetyOrange: '255, 119, 1',
    VeryPaleOrange: '255, 229, 189',
    PhilippineOrange: '255, 117, 0',
    OrangeSoda: '255, 89, 63',
    OutrageousOrange: '255, 109, 72',
    OrangeWeb: '255, 165, 0',
    Red: '255, 0, 0',
    RedRYB: '255, 39, 37',
    RedRYB2: '245, 48, 32',
    RedRYB3: '254, 40, 38',
    RedPigment: '250, 38, 38',
    RedPigment2: '255, 36, 38',
    PortlandOrange: '250, 82, 54',
    PortlandOrange2: '255, 77, 42',
    PastelRed: '247, 93, 99',
    CoralRed: '250, 69, 54',
    CoralRed2: '255, 64, 50',
    DeepCarminePink: '250, 45, 41',
    Yellow: '255, 255, 0',
    SizzlingSunrise: '252, 219, 0',
    AmberSAEECE: '255, 125, 0',
    GargoyleGas: '255, 209, 69',
    AtomicTangerine: '255, 146, 89',
    BrightOrange: '244, 191, 49',
    VerySoftYellow: '95, 98, 65',
    VividGamboge: '255, 151, 0',
    OuterSpace: '72, 77, 81',
    OuterSpace2: '67, 72, 77',
    OuterSpace3: '72, 77, 82',
    OuterSpace4: '71, 77, 81',
    OuterSpace5: '70, 75, 79',
    PhilippineGray: '140, 139, 139',
    DimGray: '98, 110, 117',
    DimGray2: '112, 105, 103',
    Gainsboro: '221, 221, 221',
    Manatee: '147, 157, 163',
    Manatee2: '146, 157, 164',
    LightSilver: '216, 216, 216',
    LightSilver2: '219, 217, 217',
    LightGray: '212, 212, 212',
    LightGray2: '211, 211, 211',
    BrightGray: '236, 236, 236',
    BrightGray2: '235, 240, 241',
    BrightGray3: '237, 236, 236',
    BrightGray4: '235, 235, 235',
    BrightGray5: '229, 237, 239',
    BrightGray6: '238, 237, 237',
    BrightGray7: '228, 233, 238',
    BrightGray8: '238, 238, 238',
    BrightGray9: '239, 239, 239',
    LavenderGray: '195, 202, 207',
    Alabaster: '236, 233, 231',
    AntiFlashWhite: '240, 242, 244',
    AntiFlashWhite2: '241, 241, 241',
    AntiFlashWhite3: '239, 241, 243',
    AntiFlashWhite4: '242, 242, 242',
    AntiFlashWhite5: '239, 242, 244',
    FloralWhite: '254, 246, 244',
    FloralYellow: '250, 245, 220',
    Cultured: '249, 249, 248',
    Cultured2: '244, 244, 244',
    Cultured3: '245, 245, 245',
    Cultured4: '243, 245, 247',
    Cultured5: '247, 248, 249',
    Cultured6: '247, 247, 247',
    Lotion: '250, 250, 250',
    Lotion2: '251, 251, 251',
    GraniteGray: '101, 101, 101',
    GraniteGray2: '102, 102, 102',
    MetallicSilver: '159, 170, 183',
    QuickSilver: '163, 163, 163',
    AmericanSilver: '208, 208, 208',
    Platinum: '226, 226, 226',
    Platinum2: '229, 229, 228',
    ChineseSilver: '204, 204, 204',
    ChineseSilver2: '200, 206, 209',
    PhilippineSilver: '184, 180, 180',
    PhilippineSilver2: '184, 184, 184',
    DavysGrey: '85, 90, 96',
    DavysGrey2: '85, 85, 85',
    DavysGrey3: '87, 84, 99',
    SonicSilver: '112, 119, 123',
    SonicSilver2: '117, 117, 117',
    DarkCharcoal: '51, 51, 51',
    PineTree: '51, 41, 39',
    PineTree2: '51, 42, 39',
    PineTree3: '51, 41, 40',
    Gunmetal: '42, 51, 56',
    Apple: '94, 207, 66',
    Mantis: '118, 214, 97',
    UFOGreen: '46, 197, 101',
    UFOGreen2: '59, 204, 103',
    PastelGreen: '108, 227, 111',
    PastelGreen2: '107, 207, 118',
    Emerald: '83, 199, 106',
    GreenPigment: '27, 186, 84',
    GreenPantone: '19, 184, 78',
    GreenPantone2: '21, 184, 78',
    MagicMint: '192, 237, 208',
    CharlestonGreen: '37, 45, 49',
    CambridgeBlue: '165, 198, 164',
    RussianGreen: '103, 143, 102',
    BlueVioletCrayola: '121, 89, 193',
    BlueViolet: '119, 38, 253',
    BlueViolet2: '143, 58, 252',
    BlueViolet3: '148, 40, 220',
    VioletRYB: '94, 0, 190',
    Ceil: '148, 148, 194',
    DarkBlueGray: '102, 102, 143',
    CongoPink: '255, 127, 127',
    SilverPink: '202, 180, 180',
    DeepTaupe: '117, 98, 98',
    DeepTaupe2: '128, 98, 96',
    Verdigris: '68, 154, 170',
    PastelBlue: '178, 195, 205',
    ColumbiaBlue: '207, 215, 225',
  },
};
